<div class="card">
    <p-accordion [multiple]="true">
        <p-accordionTab [selected]="true" header="Indirect Rates">
            <p-toolbar styleClass="mb-2" *ngIf="!cbShowAdjustments.checked">
                <div *ngIf="fyMessageDisplayed == true" class="grid">
                    <div class="col-12">
                        <p-message severity="info" [text]="fyInfoMessage"></p-message>
                    </div>
                    <div style="margin-top: -0.5rem;" class="col-12">
                        <p-message severity="warn" [text]="fyImportantNote"></p-message>
                    </div>
                </div>
            </p-toolbar>

            <form [formGroup]="indirectManagementGroup">
                <p-toolbar>
                    <div class="flex items-center">
                        <p-checkbox
                            #cbShowAdjustments
                            id="cbShowAdjustments"
                            binary="true"
                            formControlName="ShowAdjustments"
                            (onChange)="
                                ShowAdjustments.next(
                                    cbShowAdjustments.checked
                                )
                            "
                            title="Check this box to include the information necessary to adjust indirect rates for the selected fiscal year"
                        ></p-checkbox>
                        <label class="ml-2">Adjust Full Fiscal Year ( generates adjusting invoices )</label>
                    </div>
                    <p-floatLabel variant="on">
                        <p-select
                            #FY
                            appendTo="body"
                            [options]="FiscalYears"
                            [autoDisplayFirst]="false"
                            formControlName="FiscalYear"
                            [style]="{ 'min-width': '12em' }"
                            [required]="true"
                            [disabled]="!cbShowAdjustments.checked"
                        >
                        </p-select>
                        <label for="float-dd">Fiscal Year (FY)</label>
                    </p-floatLabel>
                    <button
                        pButton
                        pRipple
                        severity="secondary"
                        [hidden]="!cbShowAdjustments.checked"
                        (click)="onShowReview(true)"
                        title="This step provides a review of the adjusted FY indirect rate results PRIOR TO committing the adjusted rates."
                        label="FY Impact"
                        [disabled]="
                            this.indirectManagementGroup.controls[
                                'FiscalYear'
                            ].invalid || !enableFYImpactButton
                        "
                    ></button>
                </p-toolbar>
            </form>

            <div>
                <ef-indirect-rate-structure-container
                    [selectedError]="selectedErrorWithStatus"
                    [showAdjustments]="cbShowAdjustments.checked"
                    [FiscalYearEndDate]="FY.value ?? CurrentFiscalYear"
                    [disabled]="showReview"
                    (ShowError)="ShowError.emit($event)"
                    (Save)="onSaveRateStructure($event)"
                    (ShowRateReview)="onShowReview($event)"
                ></ef-indirect-rate-structure-container>
            </div>
        </p-accordionTab>
        <p-accordionTab [selected]="true" *ngIf="!cbShowAdjustments.checked" header="Current Fiscal Year Cost Centers">
            <ef-indirect-rate-cost-center-container
                [selectedError]="selectedError"
                (ShowError)="ShowError.next($event)"
            ></ef-indirect-rate-cost-center-container>
        </p-accordionTab>
        <p-accordionTab *ngIf="showReview" [selected]="true" header="Rate Adjustment Review">
            <div class="rate-review">
                <ef-indirect-rate-review-container
                    (SetProcessingText)="onSetProcessingText($event)"
                    [fiscalYear]="FY.value"
                    [refresh]="RefreshSubject.asObservable() | async"
                    (Cancel)="onShowReview(false); Cancel.next()"
                >
                </ef-indirect-rate-review-container>
            </div>
        </p-accordionTab>
    </p-accordion>
</div>
